<dx-popup
  id="dialog-change-unite-technique"
  [visible]="displayDialog()"
  (visibleChange)="displayDialog.set($event)"
  [deferRendering]="false"
  [width]="'1010px'"
  [height]="utils.getWindowAvailableHeight(100)"
  [showCloseButton]="false">

  <div *dxTemplate="let _ of 'title'" class="change-udm-header">
    <div class="change-udm-title">
      <yo-dialog-change-unite-technique-help></yo-dialog-change-unite-technique-help>
      Changement d'unité technique pour la denrée {{denree()?.libelle}}
    </div>

    <div class="change-udm-actions">
      <yo-button iconClass="fas fa-save" [theme]="ButtonThemeEnum.SAVE" (onClick)="saveUniteTechnique()"
                 [disabled]="!uniteTechniqueSubstitution()" tooltip="Enregistrer"></yo-button>
      <yo-button iconClass="fas fa-times" [theme]="ButtonThemeEnum.CANCEL" tooltip="Fermer"
                 (onClick)="closeDialog()"></yo-button>
    </div>
  </div>

  @if (denree()) {
    <section class="change-udm-content" [style.height.px]="utils.getWindowAvailableHeight(240)">

      <dx-data-grid
        [dataSource]="udmSvc.unitesDeMesureEnvironnement"
        keyExpr="id"
        [height]="utils.getWindowAvailableHeight(570)"
        columnResizingMode="widget"
        [cacheEnabled]="false"
        [allowColumnReordering]="true"
        (onSelectionChanged)="onSelectionChanged($event)"
        [allowColumnResizing]="true"
        [hoverStateEnabled]="true"
        [rowAlternationEnabled]="true"
        [showRowLines]="true"
        [showBorders]="true">
        <dxi-column dataField="site.libelle" alignment="center" caption="Site" [allowFiltering]="false"
                    cellTemplate="siteCellTemplate"></dxi-column>
        <dxi-column dataField="libelle" alignment="center" caption="Libelle" [allowFiltering]="true"></dxi-column>
        <dxi-column dataField="code" alignment="center" caption="Code" [allowFiltering]="true"></dxi-column>

        <div *dxTemplate="let cell of 'siteCellTemplate'">
          <yo-site [siteLibelle]="cell.data.site?.libelle" [siteId]="cell.data.site?.id"></yo-site>
        </div>

        <dxo-selection [selectAllMode]="'allPages'" [showCheckBoxesMode]="'onClick'" mode="single"></dxo-selection>
        <dxo-paging [pageSize]="50"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100]" [showNavigationButtons]="true"
                   [visible]="true" [showInfo]="true" infoText="{2} Unité de mesure"></dxo-pager>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-sorting mode="multiple"></dxo-sorting>
      </dx-data-grid>

      <div class="change-udm-comparison">
        <div class="change-udm-card">
          <span class="change-udm-card-title"><strong>Unité technique utilisée</strong></span>
          <div class="change-udm-card-body">{{denree()?.uniteDeMesure?.libelle}}</div>
        </div>

        <i class="fas fa-long-arrow-alt-right fa-3x change-udm-arrow"></i>

        <div class="change-udm-card">
          <span class="change-udm-card-title"><strong>Unité technique de substitution</strong></span>
          <div class="change-udm-card-body">{{uniteTechniqueSubstitution()?.libelle}}</div>
        </div>
      </div>

      @if (uniteTechniqueSubstitution()) {
        <div class="change-udm-ratio">
          <div class="change-udm-ratio-side">
            <strong>1 {{denree().uniteDeMesure.abreviation}}</strong>
            <span>fait {{qteOldUniteDeMesure() | number : '1.0-4'}} Kilogramme</span>
          </div>

          <i class="fas fa-long-arrow-alt-right fa-3x change-udm-arrow"></i>

          <div class="change-udm-ratio-side">
            <strong>1 {{uniteTechniqueSubstitution().abreviation}}</strong>
            <span>fait</span>
            <dx-number-box
              [width]="'150px'"
              [value]="qteNewUniteDeMesure()"
              [showSpinButtons]="true"
              [showClearButton]="true"
              (onValueChanged)="qteNewUniteDeMesure.set($event.value)">
            </dx-number-box>
            <span>Kilogramme</span>
          </div>
        </div>
      }

    </section>
  }
</dx-popup>
